import { useState } from "react";
import classNames from "classnames";
import { useItemGroups } from "atoms/itemsGropAtom";
import { Item } from "types";

import { BaseLayout } from "components/BaseLayout/BaseLayout";

import { SearchBar, ProductsList, ProductsFooter, Header } from "./components";
import { useInfiniteProducts } from "./api";
import styles from "./styles.module.scss";

export const Products = (): JSX.Element => {
  const [searchText, setSearchText] = useState("");
  const { itemGroupsState } = useItemGroups();

  const groupId = +(itemGroupsState.activeItemsGroup?.itemgroupid || "") || undefined;
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useInfiniteProducts({
    group: groupId,
    search: searchText,
  });

  // При загрузке первой страницы (смена группы/поиска) показываем пустой список, затем только результат — не добавляем к старому
  const rawItems = isLoading ? [] : (data?.pages?.flat() ?? []);
  const items: Item[] = rawItems.filter((x): x is Item => x != null);

  return (
    <BaseLayout
      className={classNames("ml-2 mt-3 mb-3", styles.container)}
      header={<Header />}
      footer={<ProductsFooter />}
    >
      <div className={styles.productsContainer}>
        <SearchBar onSearch={setSearchText} />
        <ProductsList
          items={items}
          onScrollEnd={fetchNextPage}
          hasNextPage={!!hasNextPage}
          isLoadingMore={isFetchingNextPage}
        />
      </div>
    </BaseLayout>
  );
};
